// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Monad_Except_Trans from "../Control.Monad.Except.Trans/index.js";
import * as DTS_Types from "../DTS.Types/index.js";
import * as Data_Identity from "../Data.Identity/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Ordering from "../Data.Ordering/index.js";
import * as Foreign from "../Foreign/index.js";
import * as Simple_JSON from "../Simple.JSON/index.js";
import * as TsBridge_Monad from "../TsBridge.Monad/index.js";
var pure = /* #__PURE__ */ Control_Applicative.pure(TsBridge_Monad.applicativeTsBridgeM);
var bind = /* #__PURE__ */ Control_Bind.bind(/* #__PURE__ */ Control_Monad_Except_Trans.bindExceptT(Data_Identity.monadIdentity));
var readImpl = /* #__PURE__ */ Simple_JSON.readImpl(Simple_JSON.readString);
var pure1 = /* #__PURE__ */ Control_Applicative.pure(/* #__PURE__ */ Control_Monad_Except_Trans.applicativeExceptT(Data_Identity.monadIdentity));
var fail = /* #__PURE__ */ Foreign.fail(Data_Identity.monadIdentity);
var Idle = /* #__PURE__ */ (function () {
    function Idle() {

    };
    Idle.value = new Idle();
    return Idle;
})();
var Loading = /* #__PURE__ */ (function () {
    function Loading() {

    };
    Loading.value = new Loading();
    return Loading;
})();
var Success = /* #__PURE__ */ (function () {
    function Success() {

    };
    Success.value = new Success();
    return Success;
})();
var $$Error = /* #__PURE__ */ (function () {
    function $$Error() {

    };
    $$Error.value = new $$Error();
    return $$Error;
})();
var tsBridgeRequestState = {
    tsBridge: function (v) {
        return pure(new DTS_Types.TsTypeUnion([ new DTS_Types.TsTypeTypelevelString("idle"), new DTS_Types.TsTypeTypelevelString("loading"), new DTS_Types.TsTypeTypelevelString("success"), new DTS_Types.TsTypeTypelevelString("error") ]));
    }
};
var requestStateToString = function (state) {
    if (state instanceof Idle) {
        return "idle";
    };
    if (state instanceof Loading) {
        return "loading";
    };
    if (state instanceof Success) {
        return "success";
    };
    if (state instanceof $$Error) {
        return "error";
    };
    throw new Error("Failed pattern match at Ouroboros.Models.Brands.RequestState (line 60, column 30 - line 64, column 19): " + [ state.constructor.name ]);
};
var showRequestState = {
    show: requestStateToString
};
var writeRequestState = {
    writeImpl: /* #__PURE__ */ (function () {
        var $26 = Simple_JSON.writeImpl(Simple_JSON.writeForeignString);
        return function ($27) {
            return $26(requestStateToString($27));
        };
    })()
};
var requestStateSuccess = /* #__PURE__ */ (function () {
    return Success.value;
})();
var requestStateLoading = /* #__PURE__ */ (function () {
    return Loading.value;
})();
var requestStateIdle = /* #__PURE__ */ (function () {
    return Idle.value;
})();
var requestStateError = /* #__PURE__ */ (function () {
    return $$Error.value;
})();
var requestStateFromString = function (value) {
    if (value === "idle") {
        return new Data_Maybe.Just(requestStateIdle);
    };
    if (value === "loading") {
        return new Data_Maybe.Just(requestStateLoading);
    };
    if (value === "success") {
        return new Data_Maybe.Just(requestStateSuccess);
    };
    if (value === "error") {
        return new Data_Maybe.Just(requestStateError);
    };
    return Data_Maybe.Nothing.value;
};
var requestStateNamespace = {
    idle: requestStateIdle,
    loading: requestStateLoading,
    success: requestStateSuccess,
    error: requestStateError
};
var readRequestState = {
    readImpl: function (value) {
        return bind(readImpl(value))(function (raw) {
            var v = requestStateFromString(raw);
            if (v instanceof Data_Maybe.Just) {
                return pure1(v.value0);
            };
            if (v instanceof Data_Maybe.Nothing) {
                return fail(new Foreign.ForeignError("Invalid RequestState: " + raw));
            };
            throw new Error("Failed pattern match at Ouroboros.Models.Brands.RequestState (line 77, column 5 - line 79, column 79): " + [ v.constructor.name ]);
        });
    }
};
var eqRequestState = {
    eq: function (x) {
        return function (y) {
            if (x instanceof Idle && y instanceof Idle) {
                return true;
            };
            if (x instanceof Loading && y instanceof Loading) {
                return true;
            };
            if (x instanceof Success && y instanceof Success) {
                return true;
            };
            if (x instanceof $$Error && y instanceof $$Error) {
                return true;
            };
            return false;
        };
    }
};
var ordRequestState = {
    compare: function (x) {
        return function (y) {
            if (x instanceof Idle && y instanceof Idle) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof Idle) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof Idle) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof Loading && y instanceof Loading) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof Loading) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof Loading) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof Success && y instanceof Success) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof Success) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof Success) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof $$Error && y instanceof $$Error) {
                return Data_Ordering.EQ.value;
            };
            throw new Error("Failed pattern match at Ouroboros.Models.Brands.RequestState (line 0, column 0 - line 0, column 0): " + [ x.constructor.name, y.constructor.name ]);
        };
    },
    Eq0: function () {
        return eqRequestState;
    }
};
export {
    Idle,
    Loading,
    Success,
    $$Error as Error,
    requestStateNamespace,
    requestStateIdle,
    requestStateLoading,
    requestStateSuccess,
    requestStateError,
    requestStateFromString,
    requestStateToString,
    eqRequestState,
    ordRequestState,
    showRequestState,
    readRequestState,
    writeRequestState,
    tsBridgeRequestState
};
//# sourceMappingURL=index.js.map


const RequestState = Object.fromEntries(Object.entries(requestStateNamespace).map(([key, value]) => [key.charAt(0).toUpperCase() + key.slice(1), value]));
export { RequestState };
